<template>
  <div :ref="'bankChart_' + id" style="width: 160px; height: 160px"></div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    lmtAmt: {
      type: [String, Number],
    },
    usableAmt: {
      type: [String, Number],
      default:() => {
        return 0;
      }
    },
    usedAmt: {
      type: [String, Number],
      default:() => {
        return 0;
      }
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    chartDorw() {
      let self = this;
      let myChart = this.$echarts.init(this.$refs["bankChart_" + this.id]);
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter:function(param){
            const c = ((param.data.value / self.lmtAmt) * 100).toFixed(2);
            return `${param.data.name}：${self.utils.splitK(param.data.value)}元 （${c}%）`;
          },
        },
        series: [
          {
            name: "融资额度",
            type: "pie",
            radius: ["74%", "92%"],
            avoidLabelOverlap: false,
            hoverOffset: 4,
            label: {
              normal: {
                show: true,
                position: "center",
                formatter:function(param){
                  return `{normal|额度总额}\n` + `{big|${self.utils.splitK(self.lmtAmt,'int')}}\n`;
                },
                rich:{
                  big:{
                      fontSize:14,
                      color:"#111538",
                      fontWeight:"bolder",
                      lineHeight:30,
                  },
                  normal:{
                    color:"#8A9AA8"
                  }
                },
                textStyle: {
                  color: "#555",
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "12",
                  fontFamily: "PingFangSC-Regular",
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: Number(this.usableAmt),
                name: "已用额度",
              },
              {
                value: Number(this.usedAmt),
                name: "剩余可用额度",
              },
            ],
          },
        ],
        color: ["#FF8686", "#669EFF"],
      });
    },
  },
  created() {},
  mounted() {
    this.chartDorw();
  },
  watch: {
    usableAmt(newVal){
      this.chartDorw();
    },
    // usedAmt(newVal){
    //   this.chartDorw();
    // }
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/inquiry/comprehensive-chart.vue